'use es6';

import { getFormFieldGroups } from './FormDefinition';
import { isEmpty } from 'underscore';
import { isRichTextInternalIdEqualFieldGroupInternalId } from 'FormsUI/utils/RichText';
export const canUngroupRichText = (state, richTextId) => {
  const groups = getFormFieldGroups(state);
  return groups.reduce((accum, group, index) => {
    if (isRichTextInternalIdEqualFieldGroupInternalId(group, richTextId)) {
      const nextGroup = groups[index + 1] || {};
      // Can't group onto another rich text group, or a queued group, or no group
      return group.default && (!isEmpty(group.fields) || nextGroup.default && !isEmpty(nextGroup.fields));
    }
    return accum;
  }, true);
};
export const getIsRichTextUngrouped = (state, richTextId) => {
  const groups = getFormFieldGroups(state);
  return groups.reduce((accum, fieldGroup) => {
    if (isRichTextInternalIdEqualFieldGroupInternalId(fieldGroup, richTextId)) {
      return isEmpty(fieldGroup.fields);
    }
    return accum;
  }, true);
};